(function () {
  'use strict';

  const CONFIG = {
    gridSelector: '#product-grid',
    productItemSelector: '#product-grid > .grid__item',
    buttonSelector: '.cottivaa-load-more',
    statusSelector: '.cottivaa-load-more-status',
    loadingText: 'Loading products...',
    loadedText: 'Products loaded'
  };

  let loading = false;

  function getButton() {
    return document.querySelector(CONFIG.buttonSelector);
  }

  function setLoading(button, isLoading) {
    const wrapper = button.closest('.cottivaa-load-more-wrapper');
    const status = wrapper
      ? wrapper.querySelector(CONFIG.statusSelector)
      : null;

    if (isLoading) {
      button.disabled = true;
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'LOADING...';

      if (status) {
        status.hidden = false;
        status.textContent = CONFIG.loadingText;
      }
    } else {
      button.disabled = false;
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
    }
  }

  function getNextButtonFromDocument(doc) {
    return doc.querySelector(CONFIG.buttonSelector);
  }

  function updateLoadMoreButton(nextButton) {
    const currentButton = getButton();

    if (!currentButton) {
      return;
    }

    if (!nextButton) {
      const wrapper = currentButton.closest('.cottivaa-load-more-wrapper');

      if (wrapper) {
        wrapper.remove();
      }

      return;
    }

    currentButton.dataset.nextUrl = nextButton.dataset.nextUrl || '';

    currentButton.textContent = 'LOAD MORE';
    currentButton.disabled = false;
    currentButton.classList.remove('loading');
    currentButton.removeAttribute('aria-busy');

    const currentStatus = currentButton
      .closest('.cottivaa-load-more-wrapper')
      ?.querySelector(CONFIG.statusSelector);

    if (currentStatus) {
      currentStatus.hidden = true;
    }
  }

  function extractProducts(doc) {
    return Array.from(
      doc.querySelectorAll(CONFIG.productItemSelector)
    );
  }

  async function loadMore(button) {
    if (loading) {
      return;
    }

    const nextUrl = button.dataset.nextUrl;

    if (!nextUrl) {
      return;
    }

    loading = true;

    setLoading(button, true);

    try {
      const response = await fetch(nextUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(
          'Load More request failed: ' + response.status
        );
      }

      const html = await response.text();

      const parser = new DOMParser();

      const doc = parser.parseFromString(
        html,
        'text/html'
      );

      const currentGrid = document.querySelector(
        CONFIG.gridSelector
      );

      if (!currentGrid) {
        throw new Error('Current product grid not found.');
      }

      const products = extractProducts(doc);

      if (!products.length) {
        updateLoadMoreButton(null);
        return;
      }

      /*
       * Append the products from the next page.
       */
      const fragment = document.createDocumentFragment();

      products.forEach(function (product) {
        fragment.appendChild(product);
      });

      currentGrid.appendChild(fragment);

      /*
       * Find the Load More button from the fetched page.
       * This contains the URL for the following page.
       */
      const nextButton = getNextButtonFromDocument(doc);

      updateLoadMoreButton(nextButton);

      /*
       * Notify any other Cottivaa custom code that
       * new products have been loaded.
       */
      document.dispatchEvent(
        new CustomEvent('cottivaa:products-loaded', {
          detail: {
            nextUrl: nextButton
              ? nextButton.dataset.nextUrl
              : null,
            count: products.length
          }
        })
      );

    } catch (error) {
      console.error(
        'Cottivaa Load More Error:',
        error
      );

      button.disabled = false;
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      button.textContent = 'LOAD MORE';

      const wrapper = button.closest(
        '.cottivaa-load-more-wrapper'
      );

      const status = wrapper
        ? wrapper.querySelector(
            CONFIG.statusSelector
          )
        : null;

      if (status) {
        status.hidden = false;
        status.textContent =
          'Unable to load products. Please try again.';
      }

    } finally {
      loading = false;
    }
  }

  /*
   * Event delegation.
   *
   * This is important because Dawn replaces parts
   * of the collection page when filters/sorting change.
   */
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        CONFIG.buttonSelector
      );

      if (!button) {
        return;
      }

      event.preventDefault();

      loadMore(button);
    }
  );

})();